export enum EWishListEvent {
    GET_WISH_LIST_ITEMS = 'wishList:list:get',
    ARTICLE_TOGGLE = 'wishList:article:toggle',
    ARTICLE_ADDED_TO_WISH_LIST = 'wishList:article:addedToWishList',
    LIST_UPDATE = 'wishList:list:update',
}
